import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Flex,
  Text,
  SimpleGrid,
  IconButton,
  useDisclosure,
  useMediaQuery,
  VStack, 
  Select, 
  Divider,
} from '@chakra-ui/react';
import { FaEye, FaArrowRight, FaMoneyBillWave, FaBell, FaHome, FaWallet, FaShoppingBasket, FaExchangeAlt, FaUser } from 'react-icons/fa';
import { Link } from 'react-router-dom';

import mpesa from '../imgs/mpesa.png';
import stellar from '../imgs/stellar.png'

const transactionsData = [
    { id: 1, type: 'debit', amount: -50 },
    { id: 2, type: 'credit', amount: 100 },
    { id: 3, type: 'credit', amount: 1500 },
    { id: 4, type: 'debit', amount: -50 },
    { id: 5, type: 'debit', amount: -2100 },
    { id: 6, type: 'credit', amount: 750 },
    
  ];

const UserWallet = () => {
  const [isMobile] = useMediaQuery("(max-width: 768px)");
  const { isOpen, onToggle } = useDisclosure();
  const [balance] = useState('XXXX'); // Actual balance here
  const [transactions, setTransactions] = useState([]);
  const [filteredTransactions, setFilteredTransactions] = useState([]);
  const [transactionTypeFilter, setTransactionTypeFilter] = useState('all');

  useEffect(() => {
    // Simulating API call to fetch transactions
    // Replace this with your actual API call
    setTransactions(transactionsData);
  }, []);

  useEffect(() => {
    if (transactionTypeFilter === 'all') {
      setFilteredTransactions(transactions);
    } else {
      const filtered = transactions.filter((transaction) => transaction.type === transactionTypeFilter);
      setFilteredTransactions(filtered);
    }
  }, [transactionTypeFilter, transactions]);


  return (
    <Box p={4}>
      {/* Navigation */}
      {!isMobile && (
        <Flex bg="blue.200" p={2} mt={-9} mb={4} align="center" justify="space-between">
        <Link to="/user-home">
        <Text
            size="md"
            fontWeight="semibold"
            color="white"
            _hover={{ textDecoration: 'underline', borderBottom: '3px solid white' }}
        >
            Home
        </Text>
        </Link>
          <Link to="/user-wallet">
            <Text
              size="md"
              fontWeight="semibold"
              color="white"
              _hover={{ textDecoration: 'underline', borderBottom: '3px solid white' }}
            >
              Wallet
            </Text>
          </Link>
          <Link to="/user-market">
            <Text
              size="md"
              fontWeight="semibold"
              color="white"
              _hover={{ textDecoration: 'underline', borderBottom: '3px solid white' }}
            >
              Market
            </Text>
          </Link>
          <Link to="/user-trades">
            <Text
              size="md"
              fontWeight="semibold"
              color="white"
              _hover={{ textDecoration: 'underline', borderBottom: '3px solid white' }}
            >
              Trades
            </Text>
          </Link>
          <Link to="/user-account">
            <Text
              size="md"
              fontWeight="semibold"
              color="white"
              _hover={{ textDecoration: 'underline', borderBottom: '3px solid white' }}
            >
              Account
            </Text>
          </Link>          
            <Link to="/user-notifications">        
                <IconButton
                    icon={<FaBell />}
                    variant="ghost"
                    colorScheme="blue"
                    aria-label="Notifications"
                />        
            </Link>    
        </Flex>
      )}

      {/* ... */}

      {/* Main Content */}
      <Box bg="blue.200" borderRadius="45px" p={4} mb={4} maxWidth="90%" mx="auto">
        <Flex justify="space-between" align="center" mb={4}>
          <Text fontSize="xl" fontWeight="bold">
            Wallet Balance:
          </Text>
          <Flex align="center">
            <Text fontSize="xl">{isOpen ? balance : 'XXXX'}</Text>
            <IconButton
              icon={<FaEye />}
              variant="ghost"
              colorScheme="blue"
              aria-label="Toggle Balance Visibility"
              ml={2}
              onClick={onToggle}
            />
          </Flex>
        </Flex>

        {/* Action buttons */}
        <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={4}>
          {/* Withdraw */}
          <Button
            leftIcon={<FaArrowRight />}
            colorScheme="blue"
            variant="outline"
            size="lg"
            w="100%"
            mb={4}
          >
            Withdraw
          </Button>

          {/* Transfer */}
          <Button
            leftIcon={<FaExchangeAlt />}
            colorScheme="blue"
            variant="outline"
            size="lg"
            w="100%"
            mb={4}
          >
            Transfer
          </Button>

          {/* Deposit */}
          <Button
            leftIcon={<FaMoneyBillWave />}
            colorScheme="blue"
            variant="outline"
            size="lg"
            w="100%"
            mb={4}
          >
            Deposit
          </Button>
        </SimpleGrid>
      </Box>

      
      {/* Gateways */}
      <Box bg="white" p={4}  borderRadius="45px" boxShadow="md" mb={4} borderColor="blue.200" maxWidth="80%" mx="auto">
        <Text fontWeight="semibold" m={[2, 2, 2, 2]}>Payment Gateways</Text>
        <Flex justify="space-around" align="center">
            <Flex m={[2, 2, 2, 2]}>
            <Box mr={2}>
                <img src={mpesa} alt="M-Pesa Logo" width={30} height={30} />
            </Box>
            <Box>
                <Text fontWeight="semibold">M-Pesa</Text>
                <Text fontSize="sm">Have your wallet in KES</Text>
            </Box>
            </Flex>
            <Flex m={[2, 2, 2, 2]}>
            <Box mr={2}>
                <img src={stellar} alt="Stellar Logo" width={30} height={30} />
            </Box>
            <Box>
                <Text fontWeight="semibold">Stellar</Text>
                <Text fontSize="sm">Have your wallet in Digital currency</Text>
            </Box>
            </Flex>
        </Flex>
        <Divider my={3} />
        <Text fontWeight="semibold">Currency Conversions</Text>
        <Text>
          1 KES = 0.009 USD
        </Text>
        <Text>
          1 USD = 0.000025 XLM
        </Text>
        <Divider my={3} />
        <Text fontWeight="semibold">Convert Balance</Text>
        <Flex w={["100%", "100%", "50%"]} mx="auto">
          <Select placeholder="Select currency or crypto">
            <option value="usd">USD</option>
            <option value="xlm">XLM</option>
            {/* Add more options here */}
          </Select>
          <Button ml={2} colorScheme="blue" bg={'blue.200'} size="sm">
            Convert
          </Button>
        </Flex>
      </Box>

      {/* Transaction History */}
      <Box bg="white" p={4} borderRadius="md" boxShadow="md" maxWidth="80%" mx="auto">
        <Text color="blue.200" fontWeight="semibold" fontSize="xl">
            Transaction History
        </Text>
        <VStack align="stretch" spacing={4}>
          <Select
            value={transactionTypeFilter}
            onChange={(e) => setTransactionTypeFilter(e.target.value)}
            placeholder="Filter by Type"
          >
            <option value="all">All</option>
            <option value="debit">Debit</option>
            <option value="credit">Credit</option>
          </Select>

          <Divider />

          {filteredTransactions.map((transaction) => (
            <Box
              key={transaction.id}
              bg="white"
              p={4}
              borderRadius="md"
              boxShadow="md"
            >
              <Text color="blue.200" fontWeight="bold">
                {transaction.type.toUpperCase()}
              </Text>
              <Text color={transaction.type === 'debit' ? 'red.500' : 'green.500'} fontWeight="medium">
                {transaction.amount >= 0 ? `$${transaction.amount.toFixed(2)}` : `- $${Math.abs(transaction.amount).toFixed(2)}`}
              </Text>
            </Box>
          ))}
        </VStack>
      </Box>

      {/* Mobile Navigation  */}
      {isMobile && (
        <Flex bg="blue.200" p={2} mt={4} align="center" justify="space-between" position="fixed" bottom={0} width="95%" >
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-home">
                <Flex alignItems="center" flexDirection="column">
                <FaHome />
                <Text color="white" fontSize="xs" mt={1}>
                    Home
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-wallet">
                <Flex alignItems="center" flexDirection="column">
                <FaWallet />
                <Text color="white" fontSize="xs" mt={1}>
                    Wallet
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-market">
                <Flex alignItems="center" flexDirection="column">
                <FaShoppingBasket />
                <Text color="white" fontSize="xs" mt={1}>
                    Market
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-trades">
                <Flex alignItems="center" flexDirection="column">
                <FaExchangeAlt />
                <Text color="white" fontSize="xs" mt={1}>
                    Trades
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-notifications">
                <Flex alignItems="center" flexDirection="column">
                <FaBell />
                <Text color="white" fontSize="xs" mt={1}>
                    Notifications
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-account">
                <Flex alignItems="center" flexDirection="column">
                <FaUser />
                <Text color="white" fontSize="xs" mt={1}>
                    Account
                </Text>
                </Flex>
            </Link>
            </Box>
        </Flex>
        )}

    </Box>
  );
};

export default UserWallet;
